var css = {"boxMarkerMap":"box-marker-module_boxMarkerMap__tS1Kw"};

export { css as default };
